import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncrDecrService {

  constructor() { }

  //use for encrypt JSON data to the localStorage.
  encryptJsonDataToStorage(storage, data) {
    try {
      localStorage.setItem(storage, encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data), environment.key).toString()));
    } catch (e) {
      console.log(e);
    }
  }

  //use for decrypt JSON data from the localStorage.
  decryptJsonDataFromStorage(storage) {
    try {
      var deData = CryptoJS.AES.decrypt(decodeURIComponent(localStorage.getItem(storage)), environment.key);
      return JSON.parse(deData.toString(CryptoJS.enc.Utf8));
    }
    catch (e) {
      console.log(e);
    }
  }

  //use for encrypt STRING data.
  encryptStringDataToStorage(storage, data) {
    try {
      localStorage.setItem(storage, CryptoJS.AES.encrypt(JSON.stringify(data), environment.key).toString());
    } catch (e) {
      console.log(e);
    }
  }

  //use for decrypt STRING data.
  decryptStringDataFromStorage(storage) {
    try {
      const bytes = CryptoJS.AES.decrypt(localStorage.getItem(storage), environment.key);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      console.log(e);
    }
  }


}
